export default __webpack_public_path__ + "static/media/Mobile_Apps_JTD_hdpi.f4557a48.png";